import React from 'react';

const FormatUnderline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.1665 17.5H15.8332V15.8333H4.1665V17.5ZM9.99984 14.1667C11.3259 14.1667 12.5977 13.6399 13.5354 12.7022C14.4731 11.7645 14.9998 10.4927 14.9998 9.16667V2.5H12.9165V9.16667C12.9165 9.94021 12.6092 10.6821 12.0622 11.2291C11.5153 11.776 10.7734 12.0833 9.99984 12.0833C9.22629 12.0833 8.48442 11.776 7.93744 11.2291C7.39046 10.6821 7.08317 9.94021 7.08317 9.16667V2.5H4.99984V9.16667C4.99984 10.4927 5.52662 11.7645 6.4643 12.7022C7.40199 13.6399 8.67376 14.1667 9.99984 14.1667Z" />
  </svg>
);

export default FormatUnderline;
